import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';


const BulkActionsToolbar = ({ 
  selectedCount = 0, 
  onCompare, 
  onRemove, 
  onMoveToFolder, 
  onClearSelection,
  folders = [],
  maxCompareItems = 4 
}) => {
  const [showMoveMenu, setShowMoveMenu] = useState(false);

  if (selectedCount === 0) return null;

  const folderOptions = folders?.map(folder => ({
    value: folder?.id,
    label: folder?.name
  }));

  const handleMoveToFolder = (folderId) => {
    onMoveToFolder(folderId);
    setShowMoveMenu(false);
  };

  return (
    <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 z-30 animate-slide-down">
      <div className="bg-card border border-border rounded-lg shadow-lg px-4 py-3 flex items-center space-x-4 min-w-max">
        {/* Selection Count */}
        <div className="flex items-center space-x-2">
          <div className="w-6 h-6 bg-primary rounded-full flex items-center justify-center">
            <span className="text-xs font-medium text-primary-foreground">{selectedCount}</span>
          </div>
          <span className="text-sm font-medium text-foreground">
            {selectedCount} {selectedCount === 1 ? 'property' : 'properties'} selected
          </span>
        </div>

        {/* Action Buttons */}
        <div className="flex items-center space-x-2">
          {/* Compare Button */}
          <Button
            variant="outline"
            size="sm"
            iconName="GitCompare"
            iconPosition="left"
            iconSize={14}
            onClick={onCompare}
            disabled={selectedCount > maxCompareItems}
            title={selectedCount > maxCompareItems ? `Maximum ${maxCompareItems} properties can be compared` : 'Compare selected properties'}
          >
            Compare
            {selectedCount > maxCompareItems && (
              <span className="ml-1 text-xs text-error">
                (Max {maxCompareItems})
              </span>
            )}
          </Button>

          {/* Move to Folder */}
          <div className="relative">
            <Button
              variant="outline"
              size="sm"
              iconName="FolderOpen"
              iconPosition="left"
              iconSize={14}
              onClick={() => setShowMoveMenu(!showMoveMenu)}
            >
              Move to Folder
            </Button>

            {showMoveMenu && (
              <div className="absolute bottom-full mb-2 right-0 w-48 bg-card border border-border rounded-md shadow-lg animate-slide-down">
                <div className="py-1">
                  {folders?.map((folder) => (
                    <button
                      key={folder?.id}
                      onClick={() => handleMoveToFolder(folder?.id)}
                      className="block w-full text-left px-3 py-2 text-sm text-foreground hover:bg-muted transition-colors"
                    >
                      <div className="flex items-center space-x-2">
                        <Icon name="Folder" size={14} />
                        <span>{folder?.name}</span>
                      </div>
                    </button>
                  ))}
                  
                  {folders?.length === 0 && (
                    <div className="px-3 py-2 text-sm text-muted-foreground">
                      No custom folders available
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>

          {/* Remove Button */}
          <Button
            variant="outline"
            size="sm"
            iconName="Trash2"
            iconPosition="left"
            iconSize={14}
            onClick={onRemove}
            className="text-error hover:text-error hover:border-error"
          >
            Remove
          </Button>

          {/* Clear Selection */}
          <Button
            variant="ghost"
            size="sm"
            iconName="X"
            onClick={onClearSelection}
            title="Clear selection"
          />
        </div>
      </div>
    </div>
  );
};

export default BulkActionsToolbar;